"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemDropSystem = void 0;
const Constants_1 = require("../../../Shared/Constants");
const gotti_1 = require("gotti");
const DroppedItem_1 = require("../../Assemblages/DroppedItem");
class ItemDropSystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.ITEM_DROP);
        this.droppedItemSeq = 0;
        this.droppedItems = [];
        this.itemsToPickup = [];
        this.playerJustPrssedGrab = false;
        this.timePlayerPressedGrab = 0;
        this.prevWasntGrabbed = false;
        const handleCollision = (colA, colB) => {
            const droppedItem = colB.gameObject.entity;
            if (!droppedItem)
                throw new Error(`Expected colBs gameObject data to have itemData on it.`);
            if (!this.droppedItems.includes(droppedItem)) {
                throw new Error(`Expected to be in array.`);
            }
            if (!this.itemsToPickup.includes(droppedItem)) {
                this.itemsToPickup.push(droppedItem);
            }
        };
        this.droppedItemCollisionPlugin = {
            type: 'collision',
            name: 'inventory',
            tagAs: [Constants_1.COLLIDER_TAGS.in_front_of_client_player],
            tagBs: [Constants_1.COLLIDER_TAGS.dropped_item],
            onCollisionStart: handleCollision,
            onCollision: handleCollision,
            onAfterCollisions: () => {
                const item = this.itemsToPickup.pop();
                const prevWasntGrabbed = this.prevWasntGrabbed;
                this.prevWasntGrabbed = !this.globals.clientPlayer.playerInput.pickup;
                if (item && this.globals.clientPlayer.playerInput.pickup && prevWasntGrabbed) {
                    const inv = this.globals.clientPlayer.getComponent(Constants_1.SYSTEMS.INVENTORY);
                    const itemComponent = this.getSystemComponent(item);
                    // if addItem returns false that means we couldnt add it to the inventory and do not want to delete.
                    if (this.$api.addItem(itemComponent.itemName, 1)) {
                        this.destroyEntity(item);
                        this.prevWasntGrabbed = false;
                    }
                }
                this.itemsToPickup.length = 0;
            }
        };
    }
    onClear() {
    }
    onLocalMessage(message) {
    }
    onInit() {
        this.globals.tileWorld.use(this.droppedItemCollisionPlugin);
        this.addApi(this.dropItem);
        this.addApi(this.dropItemFromPlayer);
    }
    dropItemFromPlayer(itemName) {
        const p = this.globals.clientPlayer.getPosition();
        const direction = this.globals.clientPlayer.getComponent(Constants_1.SYSTEMS.PLAYER_ANIMATION).skeleton.direction;
        return false;
    }
    dropItem(itemName, worldX, worldY, destroyTimeout) {
        const layerIndex = 1;
        const texture = this.globals.gameTextures.items.placed[itemName];
        if (!texture)
            throw new Error(`No texture found with item name: ${itemName}`);
        const gameObject = this.globals.tileWorld.addGameObject({
            texture,
            position: { x: worldX, y: worldY },
            layer: layerIndex,
            colliders: [{
                    dynamic: true,
                    layer: layerIndex,
                    shapeData: { x: 0, y: 0, w: texture.width, h: texture.height },
                    tags: [Constants_1.COLLIDER_TAGS.dropped_item, Constants_1.COLLIDER_TAGS.prevent_hole],
                }],
        });
        const entity = new DroppedItem_1.DroppedItem(this.$api.getUid());
        entity.gameObject = gameObject;
        gameObject.entity = entity;
        this.dispatchLocal({
            to: [Constants_1.SYSTEMS.GAME_STATE],
            type: Constants_1.MESSAGES.DROP_ITEM,
            data: {
                level: 'island',
                data: {
                    uid: entity.id,
                    name: itemName,
                    x: worldX,
                    y: worldY,
                }
            }
        });
        this.initializeEntity(entity, { gameObject, itemName });
        if (destroyTimeout) {
            entity.destroyTimeout = setTimeout(() => {
                delete entity.destroyTimeout;
                this.destroyEntity(entity);
            }, destroyTimeout);
        }
    }
    onEntityAddedComponent(entity, component) {
        this.droppedItems.push(entity);
    }
    onEntityRemovedComponent(entity, component) {
        if (entity.destroyTimeout) {
            clearTimeout(entity.destroyTimeout);
            delete entity.destroyTimeout;
        }
        if (entity.gameObject) {
            entity.gameObject.removeFromMap();
            delete entity.gameObject.entity;
            delete entity.gameObject;
        }
        // these props are set inside the DroppedItem.ts assemblage initialize method. (called from this.initializeEntity)
        this.droppedItems = this.droppedItems.filter(i => i !== entity);
    }
    onPeerMessage(peerId, message) {
    }
    onServerMessage(message) {
    }
    update(delta) {
        var _a, _b;
        if ((_b = (_a = this.globals.clientPlayer) === null || _a === void 0 ? void 0 : _a.playerInput) === null || _b === void 0 ? void 0 : _b.grab) {
            if (!this.timePlayerPressedGrab) {
                this.timePlayerPressedGrab = Date.now();
            }
        }
        else {
            this.timePlayerPressedGrab = 0;
        }
    }
}
exports.ItemDropSystem = ItemDropSystem;
//# sourceMappingURL=module.js.map